import React from 'react';
import { StoreDetailSpotModule } from '~/lib/data-contract';
import {
    StyledEm,
    StyledInfoRTE,
    StyledInfoSpan,
    StyledLinkRoute,
    StyledSpan,
    StyledStoreWrapper,
    StyleRoute,
    StyleRouteIcon,
} from '~/features/find-store/components/StoreMap/components/styled';
import { Store } from '~/lib/data-contract/salesforce';
import { useTranslation } from '~/shared/utils/translation';
import { isNowBetweenDates, storeWillOpen } from '~/shared/utils/date-utils';
import { getStoreHoursText } from '../../utils/get-store-hours-text';

type StoreDetailsProps = StoreDetailSpotModule;

export const StoreDetailSpot = ({
    text,
    storeList,
    spacingBottom,
    spacingTop,
    border,
    displayStoreStatus,
}: StoreDetailsProps) => {
    const { translate } = useTranslation();

    const addIsOpenNow = (openingHours: Store['c_openingHours']) =>
        openingHours?.map((time) => ({
            ...time,
            isOpen: isNowBetweenDates(time.opens, time.closes),
            willOpenToday: storeWillOpen(time.opens),
        })) ?? [];

    const openingHours = storeList?.c_openingHours ? addIsOpenNow(storeList?.c_openingHours) : [];
    const storeOpened = openingHours[0]?.isOpen;
    const linkGoogle = `https://maps.google.com/?q=${storeList?.address1},${storeList?.postalCode} ${storeList?.city}`;

    return (
        <StyledStoreWrapper
            spacingBottom={spacingBottom}
            spacingTop={spacingTop}
            border={border}
            className="storeSummary"
        >
            <StyledInfoRTE>
                {text && (
                    <div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: text,
                            }}
                        />
                    </div>
                )}
                {displayStoreStatus && (
                    <StyledInfoSpan>
                        <StyledEm storeOpened={storeOpened}>
                            {translate(storeOpened ? 'pdp.openStore' : 'pdp.closedStore')}
                        </StyledEm>
                        <span>.</span>
                        <StyledSpan>
                            {getStoreHoursText(translate, openingHours, storeList)}
                        </StyledSpan>
                    </StyledInfoSpan>
                )}
            </StyledInfoRTE>

            <StyleRoute aria-label={`Åbner Google Maps, der viser ${storeList?.name}'s placering`}>
                <StyledLinkRoute
                    href={linkGoogle}
                    title={translate('pdp.openStore')}
                    target="_blank"
                >
                    <StyleRouteIcon />
                    {translate('findStore.route')}
                </StyledLinkRoute>
            </StyleRoute>
        </StyledStoreWrapper>
    );
};
